<template>

<div class="input" :data-type="type" :class="{'is-inline': isInline, 'is-locked': isLocked}" v-click-outside="onClickOutside">

    <div class="input-icon" :data-icon="icon" v-if="icon" />

    <div class="input-label" v-if="label">{{ label }}</div>

    <div class="input-value" v-tooltip.left="(isLocked) ? 'Cannot be edited': false">
    
        <input v-if="$_.contains(['text', 'password'], type)" :type="type" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="placeholder" class="input-value-control" />

        <template v-if="type === 'toggle'">

            <div class="input-value-toggle" :class="{'is-active': parseInt(index) === value}" v-for="(text, index) in options" :key="index" v-on:click="$emit('input', parseInt(index))">

                {{ text }}

            </div>

        </template> 

        <template v-if="type === 'checklist'">

            <div class="input-value-empty" v-if="!optionCount">{{ emptyMessage || 'No options' }}</div>

            <div class="input-value-checklist" :class="{'is-active': $_.contains(value, parseInt(index))}" v-for="(text, index) in options" :key="index" v-on:click="onChecklistClick(parseInt(index))">

                {{ text }}

            </div>

        </template> 

        <template v-if="type === 'date'">

            <date-picker v-model="internalValue" type="date" format="DD/MM/YYYY" valueType="timestamp" :placeholder="placeholder" />

        </template> 

        <template v-if="type === 'suggest'">

            <input type="text" v-model="search" :placeholder="placeholder" class="input-value-control" />

            <div class="input-suggestions" v-if="$_.keys(suggestions).length">

                <div class="input-suggestions-item" v-for="(text, index) in suggestions" :key="index" v-on:click.stop="onSuggestionClick(parseInt(index), $event)" v-tooltip="(isMultiple) ? 'Shift-click to select multiple' : false" :class="{'is-active': isActiveSuggestion(parseInt(index))}">{{ text }}</div>

            </div>

        </template>

        <template v-if="type === 'select'">

            <div class="input-value-control" v-on:click.stop="onSelectClick">{{ selectText }}</div>

            <div class="input-suggestions" v-if="$_.keys(options).length && is.expanded">

                <div class="input-suggestions-item" key="reset" v-on:click.stop="onSuggestionClick(null)" v-if="resetOption">{{ resetOption }}</div>
                <div class="input-suggestions-item" v-for="(text, index) in options" :key="index" v-on:click.stop="onSuggestionClick(parseInt(index))">{{ text }}</div>

            </div>

        </template>

        <div class="input-value-copy" v-if="canCopy" v-clipboard:copy="value" v-clipboard:success="onCopy" :class="{'is-active': is.copied}"><span v-if="!is.copied">Click to copy</span><span v-if="is.copied">Copied!</span></div>
    
    </div>

</div>

</template>

<script>

import Vue from 'vue'

export default {

    props: ['label', 'placeholder', 'isLocked', 'canCopy', 'icon', 'type', 'is-multiple', 'is-inline', 'value', 'options', 'allowMultiple', 'emptyMessage', 'resetOption'],

    data: function() {
    
        return {
            is: {
                searching: false,
                expanded: false,
                copied: false
            },
            search: '',
            internalValue: false,
            suggestions: []
        }
    
    },

    created: function() {
    
        this.internalValue = this.value
    
    },

    computed: {

        selectText: function() {
        
            return (this.value) ? this.options[this.value] : this.placeholder

        },
    
        optionCount: function() {
        
            return this.$_.keys(this.options)
        
        }

    },

    watch: {

        search: function() {
        
            this.onSuggestChange()
        
        },

        value: function() {
        
            if (this.internalValue !== this.value) this.internalValue = this.value

        },
    
        internalValue: function(n) {
        
            if (n !== this.value) this.$emit('input', n)
        
        }

    },

    methods: {

        isActiveSuggestion: function(id) {

            if (this.value === null) return false
        
            return (this.isMultiple) ? this.$_.contains(this.value, id) : this.value === id
        
        },

        onCopy: function() {
        
            this.is.copied = true

            this.$_.delay(function() {
            
                this.is.copied = false

            }.bind(this), 2000)

        },

        onClickOutside: function() {
        
            this.is.expanded = false
            this.suggestions = []
            this.search = ''

        },

        onSelectClick: function() {
        
            this.is.expanded = !this.is.expanded

        },

        onSuggestChange: function() {

            if(this.is.searching) this.$api.cancel()

            if(!this.search) return false

            this.is.searching = true
        
            this.$api.get('patients/suggest', {
                text: this.search
            }).then(function(json) {
            
                Vue.set(this, 'suggestions', json.suggestions)

                this.is.searching = false
            
            }.bind(this), function() {})

        },

        onSuggestionClick: function(value, e) {

            if (value === null) {
            
                this.$emit('input', null)
            
            } else {

                if (this.isMultiple) {

                    if (e.shiftKey) {

                        var currentValue = (this.value === null) ? [] : JSON.parse(JSON.stringify(this.value))
                    
                        if(this.$_.contains(currentValue, value)) {

                            currentValue.splice(currentValue.indexOf(value), 1)
                        
                        } else {
                        
                            currentValue.push(value)

                        
                        }

                        this.$emit('input', currentValue)
                    
                    } else {
                    
                        this.$emit('input',[value])

                        this.suggestions = []
                        this.search = ''

                        this.is.expanded = false

                    }
                
                } else {
                
                    this.$emit('input', value)

                    this.suggestions = []
                    this.search = ''

                    this.is.expanded = false
                
                }
            
            }
        
        },
    
        onChecklistClick: function(value) {

            if (this.allowMultiple) {
        
                var values = this.$util.copy(this.value)

                if(this.$_.contains(values, value)) {

                    values.splice(values.indexOf(value), 1)
                
                } else {

                    values.push(value)
                
                }

                this.$emit('input', values)
            
            } else {
            
                this.$emit('input', [value])
            
            }
        
        }
    
    }

}

</script>

<style scoped>

.input {
    margin-bottom: 20px;
}

.input.is-inline {
    display: flex;
    margin-bottom: 0px;
    margin-right: 15px;
}

.input:last-child {
    margin-bottom: 0px;
}

.input-icon {
    width: 32px;
    height: 32px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    margin-right: 15px;
    margin-left: 40px;
}

.input:first-child .input-icon {
    margin-left: 0px;
}

.input-icon[data-icon="date"] {
    background-image: url(~@/assets/icon.date.png);
    background-size: 30px 33px;
}

.input-icon[data-icon="search"] {
    background-image: url(~@/assets/icon.search.png);
    background-size: 32px 32px;
}

.input-icon[data-icon="hospital"] {
    background-image: url(~@/assets/icon.hospital.png);
    background-size: 25px 32px;
}

.input-label {
    font-size: 14px;
    font-weight: 500;
    padding-left: 20px;
    margin-bottom: 10px;
    color: #333;
}

.input-value-copy {
    position: absolute;
    right: 20px;
    top: 50%;
    background-color: #005EB8;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    padding: 4px 8px;
    border-radius: 4px;
    margin-top: -11px;
    cursor: pointer;
}

.input-value-copy:hover {
    background-color: #044b8f;
}

.input-value-copy.is-active {
    background-color: #31c133;
}

.input-value-copy.is-active:hover {
    background-color: #26a427;
}

.input-value-control {
    background-color: #fff;
    height: 50px;
    border-radius: 32px;
    width: 100%;
    border: 1px solid #ddd;
    color: #333;
    font-size: 14px;
    padding: 0px 20px;
}

.input.is-locked .input-value-control {
    pointer-events: none;
}

.input.is-inline .input-value-control {
    padding: 0px 10px;
    border-radius: 4px;
    font-size: 12px;
    height: 34px;
}

.input.is-inline[data-type="select"] .input-value-control {
    width: 210px;
    line-height: 34px;
    color: #555;
    font-size: 14px;
    cursor: pointer;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    user-select: none;
}

.input.is-inline[data-type="select"] .input-value-control:hover {
    background-color: #efefef;
}

.input[data-type="toggle"] .input-value {
    display: flex;
}

.input-value-toggle {
    width: 120px;
    border: 1px solid #ddd;
    border-right: 0px;
    height: 50px;
    line-height: 48px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    user-select: none;
    color: #333;
}

.input-value-toggle:hover {
    background-color: #efefef;
}

.input-value-toggle.is-active {
    background-color: #005EB8;
    color: #fff;
    border-color: #005EB8;
}

.input-value-toggle.is-active:hover {
    background-color: #004c95;
    color: #fff;
    border-color: #004c95;
}

.input-value-toggle:first-child {
    border-top-left-radius: 32px;
    border-bottom-left-radius: 32px;
}

.input-value-toggle:last-child {
    border-top-right-radius: 32px;
    border-bottom-right-radius: 32px;
    border-right: 1px solid #ddd;
}

.input-value-checklist {
    border: 1px solid #ddd;
    border-bottom: 0px;
    height: 50px;
    line-height: 48px;
    background-color: #fff;
    padding: 0px 20px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    user-select: none;
    color: #333;
}

.input-value-checklist:hover {
    background-color: #efefef;
}

.input-value-checklist.is-active {
    background-color: #005EB8;
    color: #fff;
    border-color: #005EB8;
    border-bottom: 1px solid #fff;
}

.input-value-checklist.is-active:before {
    content: '\2713';
    margin-right: 10px;
}

.input-value-checklist.is-active:hover {
    background-color: #004c95;
    color: #fff;
    border-color: #004c95;
    border-bottom: 1px solid #fff;
}

.input-value-checklist:first-child {
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
}

.input-value-checklist:last-child {
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
    border-bottom: 1px solid #ddd;
}

.input-value >>> .mx-input {
    padding-right: 10px;
}

.input-value >>> .mx-icon-calendar {
    display: none;
}

.input-suggestions {
    position: absolute;
    top: 35px;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    left: 0px;
    background-color: #fff;
    z-index: 2;
}

.input-suggestions-item {
    font-size: 14px;
    line-height: 18px;
    color: #333;
    padding: 8px 10px;
    cursor: pointer;
    user-select: none;
    border-bottom: 1px solid #ddd;
}

.input-suggestions-item.is-active {
    background-color: #005EB8;
    color: #fff;
}

.input-suggestions-item:hover {
    background-color: #efefef;
}

.input-suggestions-item.is-active:hover {
    background-color: #00498e;
}

.input-suggestions-item:last-child {
    border-bottom: 0px;
}

</style>
